import React from 'react';
import ProductCard from './ProductCard';
import ProductPicturesCard from './ProductPicturesCard';
import ProductPrices from './ProductPrices';

class Product extends React.Component {


  render()  {
    const {productKey} = this.props.match.params;
    return (
      <div>
        <ProductCard productKey={productKey} />
        <ProductPicturesCard productKey={productKey} />
        <ProductPrices productKey={productKey} />
      </div>
    );
  }

}

export default Product;



// WEBPACK FOOTER //
// ./src/Product/Product.js